import React from "react";
import { SolutionSection } from "@/components/design-system/SolutionSection/SolutionSection";

const leftItems = [
  "Held-away assets invisible to advisors",
  "Rollover windows close before anyone acts",
  "Advisors meet participants without context",
  "Static portals with <2% engagement",
] as const;

const rightItems = [
  "Held-away IRAs and idle cash surfaced automatically",
  "Rollover and job-change signals routed to advisors",
  "Advisor Intelligence Briefs before every meeting",
  "Measurable AUM growth from each relationship",
] as const;

export const BravoSolutionSection: React.FC = () => (
  <SolutionSection
    backgroundSrc="/bg-wm-solutions.jpg"
    label="The Bravo Solution"
    heading={
      <>
        With Bravo, every interaction is{" "}
        <span className="text-primary-500">
          an AUM opportunity.
        </span>
      </>
    }
    description="Passive programs typically used to engage participants like wellness portals, emails and static content educate — they don't discover assets. Bravo guides participants while uncovering opportunity signals."
    leftItems={leftItems}
    rightItems={rightItems}
  />
);
